module.exports = __webpack_public_path__ + "static/img/LM.e5eccd09.svg";